// extracted by mini-css-extract-plugin
export default {"logo":"NotflixLogo_logo__qXUyT"};